import Head from "next/head";
import "../../styles/globals.css";
import "../cvApp/src/assets/main.css";
import "../cvApp/src/assets/formation.css";
import "../cvApp/src/assets/mapbox-gl.css";
import "../cvApp/src/assets/skills.css";
import "../cvApp/src/assets/work.css";
import "../cvApp/src/assets/home.css";
function App({ Component, pageProps }) {
  return (
    <>
      <Head>
        <title>Axel Godefroy - Portfolio</title>
        {/* <meta name="viewport" content="width=device-width, initial-scale=1.0" /> */}
      </Head>
      <Component {...pageProps} />
    </>
  );
}

export default App;
